import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { readRuntimeConfigValue } from "../runtimeConfig";

const SUPABASE_URL = String(
  readRuntimeConfigValue("REACT_APP_SUPABASE_URL") ||
    process.env.REACT_APP_SUPABASE_URL ||
    ""
).trim();
const SUPABASE_PUBLISHABLE_KEY = String(
  readRuntimeConfigValue("REACT_APP_SUPABASE_PUBLISHABLE_KEY") ||
    process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
    ""
).trim();
const SUPABASE_ANON_KEY = String(
  readRuntimeConfigValue("REACT_APP_SUPABASE_ANON_KEY") ||
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    ""
).trim();
const SUPABASE_BROWSER_KEY = SUPABASE_PUBLISHABLE_KEY || SUPABASE_ANON_KEY;

export const IS_SUPABASE_CONFIGURED = Boolean(
  SUPABASE_URL && SUPABASE_BROWSER_KEY
);

let supabaseBrowserClient: SupabaseClient | null = null;

export const getSupabaseBrowserClient = () => {
  if (!IS_SUPABASE_CONFIGURED) {
    return null;
  }

  if (!supabaseBrowserClient) {
    supabaseBrowserClient = createClient(SUPABASE_URL, SUPABASE_BROWSER_KEY, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
      global: {
        headers: {
          "X-Client-Info": "clinic-onboarding-standalone",
        },
      },
    });
  }

  return supabaseBrowserClient;
};
